import { render, staticRenderFns } from "./Item.vue?vue&type=template&id=8926a0c2&scoped=true"
import script from "./Item.vue?vue&type=script&lang=js"
export * from "./Item.vue?vue&type=script&lang=js"
import style0 from "./Item.vue?vue&type=style&index=0&id=8926a0c2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8926a0c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8926a0c2')) {
      api.createRecord('8926a0c2', component.options)
    } else {
      api.reload('8926a0c2', component.options)
    }
    module.hot.accept("./Item.vue?vue&type=template&id=8926a0c2&scoped=true", function () {
      api.rerender('8926a0c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/aggregatePageManagement/components/Item.vue"
export default component.exports